import { useContext, useState } from "react";
import PropTypes from "prop-types";
import validator from "validator";
import ResultsWrappers from "../modals/ResultsWrapper";
import SubmitApplicationLetter from "../modals/SubmitApplicationLetter";
import { Button } from "@mui/material";
import { makeStyles } from'@mui/styles';
import NextRouter from "next/router";
import moment from "moment";
import { OrganizationSticker, PremiumTeamSticker } from "../../styles/globalSVG";
import { GlobalContext } from "components/context/GlobalContext";
import { useAuth } from "components/context/auth";

const useStyles = makeStyles({
  buttonTeam: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#27AA83",
    padding: "0.5rem 1rem",
  },

  stickerStyle: {
    zIndex:20,
    position: "absolute",
    right: 0,
    top: 0,
  },
});

const TeamFound = ({ resultsType, teamObj }) => {
  // This context comes from the GlobalContext Wrapper Component
  const appState = useContext(GlobalContext);
  const { user } = useAuth();

  const classes = useStyles();
  const [showPreview, setShowPreview] = useState(false);

  const toggleTeamPreview = () => {
    setShowPreview(!showPreview);
  };

  const membershipsLength = teamObj.Memberships.length - teamObj.Memberships.filter((mem) => mem.status !== "active").length;

  const goToPublicTeamPage = () => {
    setTimeout(() => {
      NextRouter.push(`/publicteam/${teamObj.public_team_id}`);
    }, 2000);
  };

  const goToTeamPage = () => {
    // Move to public team page
    let status = false;
    teamObj.Memberships.forEach((membership) => {
      if (membership.memberId === user?.id) {
        status = true;
      }
    });
    if (status === true) {
      return NextRouter.push({
        pathname: `/team/${teamObj.public_team_id}`,
        query: { number: teamObj.id },
      });
    } else {
      return NextRouter.push(`/publicteam/${teamObj.public_team_id}`);
    }
  };

  return (
    <>
      {showPreview && (
        <ResultsWrappers togglePreview={toggleTeamPreview}>
          <SubmitApplicationLetter
            teamInfo={teamObj}
            togglePreview={toggleTeamPreview}
          />
        </ResultsWrappers>
      )}

      {teamObj.type === "organization" && resultsType === "organizations" && (
        <div style={{overflow:'hidden'}} className="container--team_display">
          <span className={classes.stickerStyle}>
            <OrganizationSticker />
          </span>
          <div className="container--team_card_top">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="svg--team_card_icon"
            >
              <path
                className="path--status_icon_path_one"
                d="M12 13a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v3a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1 1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3zM7 9a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm10 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
              />
              <path
                className="path--status_icon_path_two"
                d="M12 13a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm-3 1h6a3 3 0 0 1 3 3v3a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a3 3 0 0 1 3-3z"
              />
            </svg>
            <h3 className="header header--team_card_name">
              <Button
                className={classes.buttonTeam}
                onClick={goToPublicTeamPage}
                aria-label="Go to Public Team Page"
              >
                {teamObj.title}
              </Button>
              <div className="team-created">
                <i>
                  Created on {moment(teamObj.createdAt).format("MMMM Do, YYYY")}
                </i>
                <p className="team-members">
                  {
                    membershipsLength>1?  
                    `${membershipsLength} members`
                    :
                    `${membershipsLength} member`
                  }
                
                 

                </p>
              </div>
            </h3>
          </div>
          <hr className="hr--dashboard_page_break" />
          <div className="container--team_card_bottom">
            <h3>Creator: </h3>
            <p>{teamObj.User.fullname}</p>
            <h3>Mission: </h3>
            <p className="text--team_card_mission">
              {validator.unescape(teamObj.mission)}
            </p>
            <h3>Mission</h3>
            <p className="text--team_card_mission">{teamObj.status}</p>
          </div>
          <Button
            onClick={goToPublicTeamPage}
            className="button button--team_apply-organization"
            aria-label="View Organization"
          >
            View Organization
          </Button>
        </div>
      )}
  {teamObj.type === "premium" && resultsType === "premium" && (
        <div style={{overflow:'hidden'}} className="container--team_display">
          <span className={classes.stickerStyle}>
            <PremiumTeamSticker />
          </span>
          <div className="container--team_card_top">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="svg--team_card_icon"
            >
              <path
                className="path--status_icon_path_one"
                d="M12 13a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v3a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1 1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3zM7 9a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm10 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
              />
              <path
                className="path--status_icon_path_two"
                d="M12 13a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm-3 1h6a3 3 0 0 1 3 3v3a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a3 3 0 0 1 3-3z"
              />
            </svg>
            <h3 className="header header--team_card_name">
              <Button
                className={classes.buttonTeam}
                onClick={goToPublicTeamPage}
                aria-label="Go to Public Team Page"
              >
                {teamObj.title}
              </Button>
              <div className="team-created">
                <i>
                  Created on {moment(teamObj.createdAt).format("MMMM Do, YYYY")}
                </i>
                <p className="team-members">
                  {
                    membershipsLength>=1?  
                    `${membershipsLength} members`
                    :
                    `${membershipsLength} member`
                  }
                
                 

                </p>
              </div>
            </h3>
          </div>
          <hr className="hr--dashboard_page_break" />
          <div className="container--team_card_bottom">
            <h3>Creator: </h3>
            <p>{teamObj.User.fullname}</p>
            <h3>Mission: </h3>
            <p className="text--team_card_mission">
              {validator.unescape(teamObj.mission)}
            </p>
            <h3>Mission</h3>
            <p className="text--team_card_mission">{teamObj.status}</p>
          </div>
          <Button
            onClick={toggleTeamPreview}
            className="button button--team_apply"
            aria-label="View Team"
          >
            View  Team
          </Button>
        </div>
      )}

      {resultsType !== "organizations" && resultsType !== "premium" && 
      teamObj.type === "basic" && resultsType === "basic" &&
       (
        <div className="container--team_display">
          <div className="container--team_card_top">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="svg--team_card_icon"
            >
              <path
                className="path--status_icon_path_one"
                d="M12 13a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v3a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1 1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3zM7 9a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm10 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
              />
              <path
                className="path--status_icon_path_two"
                d="M12 13a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm-3 1h6a3 3 0 0 1 3 3v3a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a3 3 0 0 1 3-3z"
              />
            </svg>
            <h3 className="header header--team_card_name">
              <Button
                className={classes.buttonTeam}
                onClick={goToPublicTeamPage}
                aria-label="Go to Public Team Page"
              >
                {teamObj.title}
              </Button>
              <div className="team-created">
                <i>
                  Created on {moment(teamObj.createdAt).format("MMMM Do, YYYY")}
                </i>
                <p className="team-members">
                {
                    membershipsLength>1?  
                    `${membershipsLength} members`
                    :
                    `${membershipsLength} member`
                  }
                </p>
              </div>
            </h3>
          </div>
          <hr className="hr--dashboard_page_break" />
          <div className="container--team_card_bottom">
            <h3>Creator: </h3>
            <p>{teamObj.User.fullname}</p>
            <h3>Mission: </h3>
            <p className="text--team_card_mission">
              {validator.unescape(teamObj.mission)}
            </p>
            <h3>Status: </h3>
            <p className="text--team_card_mission">{teamObj.status}</p>
          </div>
          <Button onClick={goToTeamPage} className="button button--team_apply" aria-label="View Team">
            View Team
          </Button>
        </div>
      )}
    </>
  );
};

export default TeamFound;

TeamFound.propTypes = {
  teamObj: PropTypes.object,
};
